var map = {
	"./Sero Bazaar old.png": 2057,
	"./Sero Bazaar.png": 827,
	"./SeroBlue.jpg": 2058,
	"./SeroLogo.png": 2059,
	"./about-us-1.png": 1098,
	"./about-us.jpg": 1099,
	"./appbtntext.png": 2060,
	"./appstorebtn.png": 2061,
	"./backgrounds/img-01.jpeg": 2062,
	"./backgrounds/img-02.jpeg": 2063,
	"./backgrounds/spring-pat.jpg": 2064,
	"./backgrounds/spring-pat2.jpg": 2065,
	"./banners/small-banner.jpg": 2066,
	"./blog/blog-01.jpg": 609,
	"./blog/blog-02.jpg": 799,
	"./blog/blog-03.jpg": 800,
	"./blog/blog-04.jpg": 801,
	"./blog/blog-05.jpg": 802,
	"./blog/img-01.jpg": 1093,
	"./blog/img-02.jpg": 1094,
	"./blog/img-03.jpg": 1095,
	"./blog/img-04.jpg": 1096,
	"./blog/recent-01.jpg": 1100,
	"./blog/recent-02.jpg": 1101,
	"./blog/recent-03.jpg": 1102,
	"./blog/recent-04.jpg": 1103,
	"./blog/recent-05.jpg": 1104,
	"./categories/default/about-img.png": 1028,
	"./categories/default/adv-banner-img1.png": 1032,
	"./categories/default/adv-banner-img2.png": 1034,
	"./categories/default/adv-banner-img3.png": 1033,
	"./categories/default/banner-video-bg.png": 1031,
	"./categories/default/deal-bg.png": 829,
	"./categories/default/season-img1.jpg": 1029,
	"./categories/default/season-img2.jpg": 1030,
	"./categories/default/subscribe-bg.jpg": 832,
	"./categories/modern/deal-1.png": 1105,
	"./categories/modern/mail.png": 2067,
	"./categories/modern/men.jpg": 1106,
	"./categories/modern/sub-banner.jpg": 1107,
	"./categories/modern/testimonial-bg.jpg": 2068,
	"./categories/modern/women.jpg": 1108,
	"./categories/new-fashion/adv-img1.jpg": 1109,
	"./categories/new-fashion/adv-img2.jpg": 1110,
	"./categories/new-fashion/adv-img3.jpg": 1111,
	"./categories/new-fashion/adv-img4.jpg": 803,
	"./categories/new-fashion/brand-1.png": 1112,
	"./categories/new-fashion/brand-2.png": 1113,
	"./categories/new-fashion/brand-3.png": 1114,
	"./categories/new-fashion/brand-4.png": 1115,
	"./categories/new-fashion/brand-5.png": 1116,
	"./categories/new-fashion/brand-6.png": 1117,
	"./categories/new-fashion/brand-7.png": 1118,
	"./categories/new-fashion/new-letter-bg.jpg": 1119,
	"./categories/new-fashion/offer-deal-bg.jpg": 1120,
	"./categories/new-fashion/post-img1.jpg": 1121,
	"./categories/new-fashion/post-img2.jpg": 1122,
	"./categories/new-fashion/post-img3.jpg": 2069,
	"./categories/new-fashion/post-img4.jpg": 2070,
	"./categories/new-fashion/post-img5.jpg": 1123,
	"./categories/new-fashion/post-img6.jpg": 2071,
	"./categories/new-fashion/post-img7.jpg": 1124,
	"./categories/new-fashion/post-img8.jpg": 1125,
	"./categories/new-fashion/post-img9.jpg": 1126,
	"./clients/01.png": 1127,
	"./clients/02.png": 1128,
	"./clients/03.png": 1129,
	"./clients/04.png": 1130,
	"./clients/05.png": 1131,
	"./clients/06.png": 1132,
	"./clients/07.png": 1133,
	"./clients/08.png": 1134,
	"./clients/09.png": 1135,
	"./clients/10.png": 1136,
	"./clients/11.png": 1137,
	"./clients/12.png": 1138,
	"./clients/ForwardOnly.jpg": 2072,
	"./clients/ForwardOnly.png": 2073,
	"./clients/underProduction.jpg": 2074,
	"./clients/underProduction.png": 2075,
	"./comingsoon.png": 833,
	"./empty-cart.png": 2076,
	"./empty-search.jpg": 328,
	"./error-404-image.png": 834,
	"./favicon.png": 2077,
	"./google-play-img.png": 2078,
	"./home-01-slider/img-01.jpg": 1036,
	"./home-01-slider/img-02.jpg": 1037,
	"./home-02-slider/Freezone Image SF 11263-1 & 11109-2 - 1340 x 650.jpg": 2079,
	"./home-02-slider/Freezone Image SF 11263-1 & 11109-2.jpg": 2080,
	"./home-02-slider/HV Image HV 9065-4 9065-5 & 7054-1 8489-2 - 1340 x 650.jpg": 2081,
	"./home-02-slider/HV Image HV 9065-4 9065-5 & 7054-1 8489-2.jpg": 2082,
	"./home-02-slider/Home Page  HV.png": 2083,
	"./home-02-slider/Home Page Freezone.png": 2084,
	"./home-02-slider/Home Page Sero.png": 2085,
	"./home-02-slider/Home Page Trouser.png": 2086,
	"./home-02-slider/Sero Image 1340 x 650.png": 2087,
	"./home-02-slider/Sero Image 1920 - 1080.png": 2088,
	"./home-02-slider/Sero Image PRIME 85-1 & PRIME 124-2 - 1340 x 650.jpg": 2089,
	"./home-02-slider/Sero Image PRIME 85-1 & PRIME 124-2.jpg": 2090,
	"./home-02-slider/Tile Image  - HV 9068-1 & 5.jpg": 2091,
	"./home-02-slider/Tile Image  - SF 11209-2 (1).jpg": 2092,
	"./home-02-slider/Tile Image - Cotton Trouser (1).jpg": 2093,
	"./home-02-slider/Tile Image - EGO 6016-1 (1).jpg": 2094,
	"./home-02-slider/Tile Image - KAL - 2 (1).jpg": 2095,
	"./home-02-slider/Tile Image - PRIME 124-2 (1).jpg": 2096,
	"./home-02-slider/Tile Image - White Gold (1).jpg": 2097,
	"./home-02-slider/Tile Image UTH 2176-2 (1).jpg": 2098,
	"./home-02-slider/Trouser Image - Opt 1 - 1340 x 650.jpg": 2099,
	"./home-02-slider/Trouser Image - Opt 1.jpg": 2100,
	"./home-02-slider/Trouser Image 1340 x 650.png": 2101,
	"./home-02-slider/Trouser Image 1920-1080.png": 2102,
	"./home-02-slider/img-01.jpg": 1139,
	"./home-02-slider/img-02.jpg": 1140,
	"./home-03-slider/img-01.jpg": 1141,
	"./home-03-slider/img-02.png": 1142,
	"./home-03-slider/img-03.png": 1143,
	"./home-03-slider/img-04.jpg": 1144,
	"./home-03-slider/img-05.png": 1145,
	"./home-03-slider/img-06.png": 1146,
	"./home-04-slider/img-01.jpg": 1147,
	"./home-04-slider/img-02.jpg": 1148,
	"./home-04-slider/sale-02.png": 1149,
	"./home-04-slider/sale.png": 1150,
	"./loader-2.svg": 2103,
	"./loader.svg": 2104,
	"./logo.svg": 835,
	"./maintenance.png": 836,
	"./newsletter/img-03.jpg": 837,
	"./payments.png": 2105,
	"./product-single.jpg": 2106,
	"./products/product-01.jpg": 1151,
	"./sero-shirts.jpg": 2107,
	"./shop/accessroies/b.jpg": 2108,
	"./shop/accessroies/b1.jpg": 2109,
	"./shop/accessroies/b2.jpg": 2110,
	"./shop/accessroies/b3.jpg": 2111,
	"./shop/athleisure/a.jpg": 2112,
	"./shop/athleisure/a1.jpg": 2113,
	"./shop/athleisure/a2.jpg": 2114,
	"./shop/athleisure/b.jpg": 2115,
	"./shop/athleisure/b1.jpg": 2116,
	"./shop/athleisure/c.jpg": 2117,
	"./shop/athleisure/c1.jpg": 2118,
	"./shop/bags/a.jpg": 2119,
	"./shop/bags/a1.jpg": 2120,
	"./shop/bags/a2.jpg": 2121,
	"./shop/bags/a3.jpg": 2122,
	"./shop/blazers/a.jpg": 2123,
	"./shop/blazers/b.jpg": 2124,
	"./shop/blazers/b1.jpg": 2125,
	"./shop/blazers/c.jpg": 2126,
	"./shop/blazers/c1.jpg": 2127,
	"./shop/blazers/c2.jpg": 2128,
	"./shop/blazers/c3.jpg": 2129,
	"./shop/blazers/d.jpg": 2130,
	"./shop/blazers/d1.jpg": 2131,
	"./shop/blazers/d2.jpg": 2132,
	"./shop/boys/a.jpg": 2133,
	"./shop/boys/a1.jpg": 2134,
	"./shop/boys/a2.jpg": 2135,
	"./shop/cat-01.png": 2136,
	"./shop/cat-02.png": 2137,
	"./shop/cat-03.png": 2138,
	"./shop/cat-04.png": 2139,
	"./shop/cat-05.png": 2140,
	"./shop/clothing/a.jpg": 2141,
	"./shop/clothing/a1.jpg": 2142,
	"./shop/clothing/a2.jpg": 2143,
	"./shop/clothing/b.jpg": 2144,
	"./shop/clothing/b1.jpg": 2145,
	"./shop/clothing/b2.jpg": 2146,
	"./shop/clothing/b3.jpg": 2147,
	"./shop/clothing/c.jpg": 2148,
	"./shop/clothing/c1.jpg": 2149,
	"./shop/clothing/c2.jpg": 2150,
	"./shop/coats-jackets/a.jpg": 2151,
	"./shop/coats-jackets/a1.jpg": 2152,
	"./shop/coats-jackets/b.jpg": 2153,
	"./shop/coats-jackets/b1.jpg": 2154,
	"./shop/coats-jackets/b2.jpg": 2155,
	"./shop/coats-jackets/c.jpg": 2156,
	"./shop/coats-jackets/c1.jpg": 2157,
	"./shop/dresswear/a.jpg": 2158,
	"./shop/dresswear/a1.jpg": 2159,
	"./shop/dresswear/a2.jpg": 2160,
	"./shop/dresswear/a3.jpg": 2161,
	"./shop/dresswear/b.jpg": 2162,
	"./shop/dresswear/b1.jpg": 2163,
	"./shop/dresswear/c.jpg": 2164,
	"./shop/dresswear/c1.jpg": 2165,
	"./shop/gadgets/g-1-a.jpg": 2166,
	"./shop/gadgets/g-1-b.jpg": 2167,
	"./shop/gadgets/g-1-c.jpg": 2168,
	"./shop/gadgets/g-1-d.jpg": 2169,
	"./shop/gadgets/g-2-a.jpg": 2170,
	"./shop/gadgets/g-2-b.jpg": 2171,
	"./shop/gadgets/g-2-c.jpg": 2172,
	"./shop/gadgets/g-2-d.jpg": 2173,
	"./shop/gadgets/g-3-a.jpg": 2174,
	"./shop/gadgets/g-3-b.jpg": 2175,
	"./shop/gadgets/g-3-c.jpg": 2176,
	"./shop/gadgets/g-3-d.jpg": 2177,
	"./shop/gadgets/g-4-a.jpg": 2178,
	"./shop/gadgets/g-4-b.jpg": 2179,
	"./shop/gadgets/g-4-c.jpg": 2180,
	"./shop/gadgets/g-4-d.jpg": 2181,
	"./shop/gadgets/g-4-e.jpg": 2182,
	"./shop/gadgets/g-5-a.jpg": 2183,
	"./shop/gadgets/g-5-b.jpg": 2184,
	"./shop/gadgets/g-5-c.jpg": 2185,
	"./shop/gadgets/g-5-d.jpg": 2186,
	"./shop/girls/a.jpg": 2187,
	"./shop/girls/a1.jpg": 2188,
	"./shop/girls/a2.jpg": 2189,
	"./shop/girls/a3.jpg": 2190,
	"./shop/girls/b.jpg": 2191,
	"./shop/girls/b1.jpg": 2192,
	"./shop/girls/b2.jpg": 2193,
	"./shop/girls/b3.jpg": 2194,
	"./shop/grid-2-icon.png": 2195,
	"./shop/grid-3-icon.png": 2196,
	"./shop/grid-4-icon.png": 2197,
	"./shop/img-01.jpg": 2198,
	"./shop/img-02.jpg": 1152,
	"./shop/img-03.jpg": 2199,
	"./shop/jumpsuits/a.jpg": 2200,
	"./shop/jumpsuits/a1.jpg": 2201,
	"./shop/jumpsuits/b.jpg": 2202,
	"./shop/jumpsuits/b1.jpg": 2203,
	"./shop/juniors/a.jpg": 2204,
	"./shop/juniors/a1.jpg": 2205,
	"./shop/juniors/b.jpg": 2206,
	"./shop/juniors/b1.jpg": 2207,
	"./shop/kids/a.jpg": 2208,
	"./shop/kids/a1.jpg": 2209,
	"./shop/kids/a2.jpg": 2210,
	"./shop/kids/b.jpg": 2211,
	"./shop/kids/b1.jpg": 2212,
	"./shop/list-icon.png": 2213,
	"./shop/men/a.jpg": 2214,
	"./shop/men/a1.jpg": 2215,
	"./shop/men/a2.jpg": 2216,
	"./shop/men/b.jpg": 2217,
	"./shop/men/b1.jpg": 2218,
	"./shop/men/b2.jpg": 2219,
	"./shop/men/c.jpg": 2220,
	"./shop/men/c1.jpg": 2221,
	"./shop/men/c2.jpg": 2222,
	"./shop/men/shirts1.jpg": 2223,
	"./shop/men/shirts10.jpg": 2224,
	"./shop/men/shirts11.jpg": 2225,
	"./shop/men/shirts12.jpg": 2226,
	"./shop/men/shirts2.jpg": 2227,
	"./shop/men/shirts3.jpg": 2228,
	"./shop/men/shirts4.jpg": 2229,
	"./shop/men/shirts5.jpg": 2230,
	"./shop/men/shirts6.jpg": 2231,
	"./shop/men/shirts7.webp": 2232,
	"./shop/men/shirts9.jpg": 2233,
	"./shop/new-arrivals/a.jpg": 2234,
	"./shop/new-arrivals/a1.jpg": 2235,
	"./shop/new-arrivals/b.jpg": 2236,
	"./shop/new-arrivals/b1.jpg": 2237,
	"./shop/new-arrivals/c.jpg": 2238,
	"./shop/new-arrivals/c1.jpg": 2239,
	"./shop/outfits/a.jpg": 2240,
	"./shop/outfits/a1.jpg": 2241,
	"./shop/outfits/b.jpg": 2242,
	"./shop/outfits/b1.jpg": 2243,
	"./shop/outfits/b2.jpg": 2244,
	"./shop/pajamas-robes/a.jpg": 2245,
	"./shop/pajamas-robes/a1.jpg": 2246,
	"./shop/pajamas-robes/b.jpg": 2247,
	"./shop/pajamas-robes/b1.jpg": 2248,
	"./shop/qr_code-bg.png": 2249,
	"./shop/sale-banner.jpg": 2250,
	"./shop/sale-banner2.jpg": 1153,
	"./shop/shoes/a.jpg": 2251,
	"./shop/shoes/a1.jpg": 2252,
	"./shop/shoes/a2.jpg": 2253,
	"./shop/shop-banner.jpg": 2254,
	"./shop/size-icon.png": 2255,
	"./shop/women/a.jpg": 2256,
	"./shop/women/a1.jpg": 2257,
	"./shop/women/a2.jpg": 2258,
	"./shop/women/b.jpg": 2259,
	"./shop/women/b1.jpg": 2260,
	"./shop/women/c.jpg": 2261,
	"./shop/women/c1.jpg": 2262,
	"./shop/women/c2.jpg": 2263,
	"./sub-banner-01-1.png": 1154,
	"./sub-banner-02-1.jpg": 1155,
	"./team/img-01.jpg": 1156,
	"./team/img-02.jpg": 1157,
	"./team/img-03.jpg": 1158,
	"./team/img-04.jpg": 1159,
	"./team/img-05.jpg": 1160,
	"./team/img-06.jpg": 1161,
	"./team/img-07.jpg": 1162,
	"./team/img-08.jpg": 1163,
	"./testimonials/a1.jpg": 1164,
	"./testimonials/img-01.jpg": 804,
	"./testimonials/img-02.jpg": 394,
	"./testimonials/img-03.jpg": 805,
	"./testimonials/img-04.jpg": 806,
	"./testimonials/profilelogo.png": 1165,
	"./tiles/Home Page  HV.png": 2264,
	"./tiles/Home Page Freezone.png": 2265,
	"./tiles/Home Page Sero.png": 2266,
	"./tiles/Home Page Trouser.png": 2267,
	"./tiles/Tile Cotton Trouser.jpg": 2268,
	"./tiles/Tile Denim.jpg": 2269,
	"./tiles/Tile Formal Trouser.jpg": 2270,
	"./tiles/Tile Freezone.jpg": 2271,
	"./tiles/Tile HV.jpg": 2272,
	"./tiles/Tile Image - Freezone - SF 11078-2 (1).png": 2273,
	"./tiles/Tile Image - HV 7054 (1).png": 2274,
	"./tiles/Tile Image - Sero Formal.png": 2275,
	"./tiles/Tile Image - Sero Marry me.png": 2276,
	"./tiles/Tile Image - Sero Premium.png": 2277,
	"./tiles/Tile Image - Sero Uth.png": 2278,
	"./tiles/Tile Image - Sero WhiteGold.png": 2279,
	"./tiles/Tile Image - Sero without buttons.png": 2280,
	"./tiles/Tile Image - Sero.png": 2281,
	"./tiles/Tile Image 1.png": 2282,
	"./tiles/Tile Image 2.png": 2283,
	"./tiles/Tile Image 3.png": 2284,
	"./tiles/Tile Image 4.png": 2285,
	"./tiles/Tile Image 5.png": 2286,
	"./tiles/Tile Sero.jpg": 2287,
	"./tiles/freezone.jpeg": 2288,
	"./tiles/hvPremium.jpeg": 2289,
	"./tiles/seroTitle.jpeg": 2290,
	"./toggle.svg": 2291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 163;